import { render, staticRenderFns } from "./zAguardar.vue?vue&type=template&id=2be1dbe4&scoped=true&"
import script from "./zAguardar.vue?vue&type=script&setup=true&lang=js&"
export * from "./zAguardar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1dbe4",
  null
  
)

export default component.exports